import { useBoardState } from '../store/context'
import { NewProjectPage } from '../projects/NewProjectPage'

export function ProjectsSettings() {
  const { projects } = useBoardState()
  return <>
    <section className="settings-section">
      <ul className="settings-rows" aria-label="Projects">
        {[...projects.values()].map(project => <li key={project.id}>
          <div className="settings-row-line"><span className="settings-row-what">{project.name}<span className="muted">{project.repository ?? 'No repository yet'}</span></span><span className="muted">{project.key}</span></div>
        </li>)}
      </ul>
    </section>
    <NewProjectPage />
  </>
}
